import React, { useState, useEffect } from "react";
import CustomAccordion, { CustomAccordionToggle, CustomAccordionContent } from "../CustomAccordion";
import { UtilityNavMenuItemHeader } from "components/shared/views/UtilityNavView";
/**
 * @name MainNavCustomAccordion
 * @function
 * @param {BOOLEAN} label - The label for the main item in the accordion.
 * @param {BOOLEAN} isOpen - Determines if the accordion is open.
 * @param {STRING} dataPoint - Data point for the main item in the accordion.
 * @param {STRING} children - Children passed to this component.
 * @extends React.Component
 * @exported true
 * @description The main nav wrapper for a custom accordion
 * @notes *isOpen* property by default is set to false
 * @example
 * export deafult function Component(props) {
 *  return (
 *      <div className="utility-nav-menu-item clickable utility-nav-menu-accordion" data-point={ point }>
            <MainNavCustomAccordion className="menu-nav-item-accordion" activeClass="sub-nav-open" dataPoint={ point } label={ props.label }>
                { props.children }
            </MainNavCustomAccordion>
        </div>
 *  );
 * }
 */
export default function MainNavCustomAccordion(props) {
    const useMainNavUI = true;
    const dataPoint = props.dataPoint ? { dataPoint: props.dataPoint } : {};

    return (
    <CustomAccordion { ...dataPoint } className="menu-nav-item-accordion main-nav-custom" activeClass="sub-nav-open">
        <CustomAccordionToggle className="main-nav-custom">
            <UtilityNavMenuItemHeader class="main-nav-dropdown" label={ props.label } useMainNavUI={ useMainNavUI } />
        </CustomAccordionToggle>

        <CustomAccordionContent className="flex-container flex-vertical main-nav-custom">
            { props.children }
        </CustomAccordionContent>
    </CustomAccordion>
    );
}